import {RouteContext} from "../../../RouteContext";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";
import {ShoppingPathBrowserValueObject} from "../../../../model/vo/content/ShoppingPathBrowserValueObject";
import {ShoppingPathBrowserIO} from "../../../../io/content/ShoppingPathBrowserIO";

import {
    Button,
    Dialog,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger, makeStyles
} from "@fluentui/react-components";
import {browserName} from "../../../../constant/Browser";
import {visibilityName} from "../../../../constant/Visibility";


const useClasses = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
    },
    textNone: {
        textDecorationColor:"#cecccb"
    },
    text: {
        textDecorationColor: "black",
        fontWeight: "bold"
    }
})

export default function List(props: RouteContext) {

    const classes = useClasses()

    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingPathBrowserValueObject.description}
                list={ShoppingPathBrowserIO.list}
                count={ShoppingPathBrowserIO.count}
                delete={ShoppingPathBrowserIO.delete}
                postHref={'/admin/shoppings/pathBrowsers/post'}
                detailHref={item => `/admin/shoppings/pathBrowsers/${item.id}`}
                editHref={item => `/admin/shoppings/pathBrowsers/edit/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                itemValue={(item, key) => {
                  if(key === 'browser'){
                        return<>
                            <Dialog modalType="non-modal">
                                <DialogTrigger disableButtonEnhancement>
                                    <Button>{item.browser}</Button>
                                </DialogTrigger>
                                <DialogSurface>
                                    <DialogBody>
                                        <DialogTitle>브라우저</DialogTitle>
                                        <DialogContent>
                                            {
                                                    browserName.map((name, idx) => {
                                                    const isVisible = !!(Number(item.browser) & (1 << idx));
                                                    return (
                                                    <div key={idx} className={isVisible ? classes.text : classes.textNone}>
                                                        {name}
                                                    </div>
                                                );})
                                            }
                                        </DialogContent>
                                    </DialogBody>
                                </DialogSurface>
                            </Dialog>
                        </>

                    }
                }}
            />
        </Column>
    </>
}